import {ACTION_GET_USER_INFO} from '../../constant/eventbus'
import {USERCENTER_TICKET, MSITE_HDCN, MSITE_UUID, AUTO_LOGIN_METHOD} from '../../constant/CookieKeys'
import {api_logout} from '../../api/index'
import {url_without_ticket} from './ticket'
import * as Cookie from 'tiny-cookie';

export function show_login_expired() {
  clearCookie();
  window.$toast('登陆信息已过期');
}


export function login() {
  setTimeout(() => {
    if (gact.is_h5 || gact.debug) {
      clearCookie();
      setTimeout(() => {
        window.location.href = `${gact.config.h5_login}?from= ${encodeURIComponent(url_without_ticket(window.location.href))}`;
      }, 300)
    } else {
      MgtvApi.login(data => {
        const userInfo = data && JSON.parse(data);
        window.$bus.$emit(ACTION_GET_USER_INFO, userInfo.ticket);
      });
    }
  }, 300);
}


export function logout() {

  Cookie.remove(MSITE_HDCN, {domain: "mgtv.com"}); //删除m站的ticket
  Cookie.remove(MSITE_UUID, {domain: "mgtv.com"}); //删除m站的ticket
  window.localStorage.removeItem(USERCENTER_TICKET); //删除原有用户中心的ticket
  if (gact.is_h5) {
    api_logout();
  }
  setTimeout(() => {
    if (gact.is_h5 || gact.debug) {
      window.location.href = `${gact.config.h5_login}?from= ${encodeURIComponent(url_without_ticket(window.location.href))}`;
    }
  }, 500);
}


export function clearCookie() {
  Cookie.remove('HDCN', {domain: "mgtv.com"});
  Cookie.remove('uuid', {domain: "mgtv.com"});
  Cookie.remove('ticket', {domain: "mgtv.com"});
  Cookie.remove(AUTO_LOGIN_METHOD, {domain: "mgtv.com"});
  window.localStorage.removeItem('usercenter_t');

}


function platForm() {
  const ua = window.navigator.userAgent;
  if (/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/WeiBo/i.test(ua)) {
    return 'weibo'
  } else if (/\sQQ/i.test(navigator.userAgent)) {
    return 'qq'
  }
  return 'unknow'
}

export function autoLogin(cancelCB) {
  if (gact.is_h5) {
    let target = platForm();

    const link = encodeURIComponent(url_without_ticket(window.location.href))
    let loginUrl = null;
    let platformName = ''
    switch (target) {
      case 'weixin':
        platformName = '微信';
        loginUrl = 'https://club.api.mgtv.com/cj/weixin2/auth?dire_url=' + link
        break;
      case 'weibo':
        platformName = '微博';
        loginUrl = 'https://club.api.mgtv.com/cj/oauth/weibo?dire_url=' + link
        break;
      case 'qq':
        platformName = 'QQ';
        loginUrl = 'https://club.api.mgtv.com/cj/oauth/qq?dire_url=' + link
        break;
    }
    if (loginUrl) {
      window.$dialog.confirm({
        message: `是否使用${platformName}账号进行登陆?`
      }).then(() => {
        Cookie.set(AUTO_LOGIN_METHOD, target, {domain: "mgtv.com"})
        window.location.href = loginUrl;
      }).catch(() => {
        if (cancelCB) {
          cancelCB();
        }
      });
    } else {
      cancelCB();
    }
  }

}



// WEBPACK FOOTER //
// ./src/tools/mgtv/login.js